import store from '../../../store';

// INPUT transformations

// used to put quote object attributes in the exact order expected by table and grid layouts
export function categoryOrderedObject(account = null) {
  //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
  return function metalsOrderedObjectInnerFunc(quote) {
    // this has to exactly follow the column order laid out by gridLayout
    return {
      assetName: store.getState().data.unlistedShares.accounts.find((a) => a.id === quote.assetId).name,
      date: quote.date,
      source: quote.source,
      quoteBaseCurrency: quote.quoteBaseCurrency,
      currency: quote.currency,
      quote: quote.quote,
      note: quote.note,
    };
  };
}

// applies category-related final changes before sending to Grid
// add displaySymbol based on figi
export function applyCategorySpecificChanges(_quotes, account = null) {
  return _quotes.map(categoryOrderedObject());
}

// OUTPUT transformations

// used inside of .map
// performs category - specific transformations after standard transformations of Grid output
// seqeunce of properties is no longer important
// this happens already after items with inputFlag = 'delete' have been added, so just take care of 'put'
export function outputTransformCategoryQuotes(account = null) {
  //  outer function takes a parameter returns a CALLBACK function for .map with that parameter already in
  return function outputTransformMetalsQuotesInnerFunc(item) {
    return {
      ...item,
      source: item.source || 'manual',
      importFlag: item.importFlag || 'put',
    };
  };
}
